<template>
  <b-row class="mb-2">
    <b-col cols="2">{{ service.text }}</b-col>
    <b-col cols="1">{{ service.done }}</b-col>
    <b-col>
      <b-button
       variant="primary"
       @click="goToUpdateService()">
       Editar
      </b-button>

      <b-button
       variant="warning"
       class="ml-2"
       @click="updateServiceStatus()">
       Estado
      </b-button>

       <b-button
       variant="danger"
       class="ml-2"
       @click="removeService(service.id)">
       Eliminar
      </b-button>

    </b-col>
  </b-row>
</template>

<script>
import {mapMutations, mapActions} from 'vuex'
 export default {
  props: {
    servicio: {
      type: Object,
      required: true
    }},
    methods: {
      ...mapActions({
        _updateServiceStatus: 'services/updateServicioStatus',
        _removeService: 'services/removeServicio',
      }),
      ...mapMutations('services',['setServicio']),
      goToUpdateService() {
        this.setService(this.servicio)
        this.$router.push({
          name: 'service-update',
          params: {id: this.servicio.id}
        })
      },
      updateServiceStatus () {
        this._updateServiceStatus(this.servicio)
      },
      removeService () {
        this._removeService(this.servicio.id)
      }
    }
 }

</script>
